export default __webpack_public_path__ + "static/media/bannerBackground.7c6a5699.png";